import React, { useState } from "react";
import { message, Dropdown } from "antd";
import { DownOutlined, RightOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useGetSidebarMenu } from "./menus";
import { useSelector } from "react-redux";

const SubHeader = () => {
  const navigate = useNavigate();
  const { user, superUser } = useSelector((state) => state?.auth);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();
  const { menu, superMenu } = useGetSidebarMenu(setOpenDropdown, messageApi);

  const menuItems = user?.id ? menu : superUser?.id ? superMenu : [];

  const handleClick = (path, key) => {
    if (key?.toLowerCase() === "dashboard") {
      navigate("/dashboard");
    } else if (path) {
      navigate(path);
    }
  };

  // Recursive builder with controlled spacing
  const buildMenuItems = (items, level = 0) => {
  return items.map((child) => {
    if (child.children && child.children.length > 0) {
      return {
        key: child.key,
        label: child.label,
        isPinned: child.isPinned,
        rightId: child.rightId,
        children: buildMenuItems(child.children, level + 1), // pass level
      };
    }
    return {
      key: child.key,
      isPinned: child.isPinned,
      rightId: child.rightId,
      label: (
        <div
          className={`dropdown-item ${level > 1 ? "nested-child" : ""}`}
        >
          <span className="dropdown-text">{child.label}</span>
        </div>
      ),
      onClick: () => handleClick(child.path, child.key),
    };
  });
};

  return (
    <div
      className="sub-menu"
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "row",
        gap: "8px",
        alignItems: "center",
        marginBottom: "10px",
        background: "#ffffff",
        padding: "6px 10px",
        boxShadow: "0 1px 6px rgba(0,0,0,0.06)",
        overflowX: "auto",
        overflowY: "hidden",
        border: "1px solid #f0f0f0",
      }}
    >
      {contextHolder}
      {menuItems.map((item) =>
        item?.children && item.children.length > 0 ? (
          <Dropdown
            key={item.key}
            open={openDropdown === item.key}
            onOpenChange={(visible) =>
              setOpenDropdown(visible ? item.key : null)
            }
            menu={{
              items: buildMenuItems(item.children),
              style: {
                boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
                padding: "4px 0", // tighter vertical spacing
                maxHeight: '400px',
                overflow: 'auto',
                height: '-webkit-fill-available',
              },
            }}
            trigger={["click"]}
            placement="bottomLeft"
          >
            <div
              style={{
                cursor: "pointer",
                padding: "5px 10px",
                borderRadius: "6px",
                fontWeight: 500,
                fontSize: "14px",
                color: "#2c3e50",
                background: "transparent",
                transition: "all 0.2s ease",
                display: "flex",
                alignItems: "center",
                whiteSpace: "nowrap",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background =
                  "rgba(22, 119, 255, 0.08)";
                e.currentTarget.style.color = "#1677ff";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "transparent";
                e.currentTarget.style.color = "#2c3e50";
              }}
            >
              {item.label}
              <DownOutlined style={{ marginLeft: 4, fontSize: "10px" }} />
            </div>
          </Dropdown>
        ) : (
          <div
            key={item.key}
            style={{
              cursor: "pointer",
              padding: "5px 10px",
              borderRadius: "6px",
              fontWeight: 500,
              fontSize: "14px",
              color: "#2c3e50",
              background: "transparent",
              transition: "all 0.2s ease",
              whiteSpace: "nowrap",
            }}
            onClick={() => handleClick(item.path, item.key)}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(22, 119, 255, 0.08)";
              e.currentTarget.style.color = "#1677ff";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "transparent";
              e.currentTarget.style.color = "#2c3e50";
            }}
          >
            {item.label}
          </div>
        )
      )}
    </div>
  );
};

export default SubHeader;
